module.exports = __webpack_public_path__ + "static/media/logout.5856e86d.svg";